var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 69,
    width: 96,
    height: 96
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-950 -69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M985.293 111.293 974.586 122 985.293 132.707 986.707 131.293 977.414 122 986.707 112.707 985.293 111.293Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.29 112.707 1018.59 122 1009.29 131.293 1010.71 132.707 1021.41 122 1010.71 111.293 1009.29 112.707Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.083 133.601 1002.08 110.601 1003.92 111.398 993.917 134.399Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958 148 1038 148 1038 86 958 86ZM960 146 960 102 1036 102 1036 146ZM1036 88 1036 100 960 100 960 88Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015 94C1015 95.1046 1014.1 96 1013 96 1011.9 96 1011 95.1046 1011 94 1011 92.8954 1011.9 92 1013 92 1014.1 92 1015 92.8954 1015 94Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022 94C1022 95.1046 1021.1 96 1020 96 1018.9 96 1018 95.1046 1018 94 1018 92.8954 1018.9 92 1020 92 1021.1 92 1022 92.8954 1022 94Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029 94C1029 95.1046 1028.1 96 1027 96 1025.9 96 1025 95.1046 1025 94 1025 92.8954 1025.9 92 1027 92 1028.1 92 1029 92.8954 1029 94Z",
    fill: "#1976D2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help_icon.81677d035431322240ffb9d40b9355fa.svg";
export { ForwardRef as ReactComponent };